const menuOpener = document.querySelector('.js-menu-open');
const menuCloser = document.querySelector('.js-menu-close');
const menu = document.querySelector('.js-menu');
const menuWrapper = document.querySelector('.js-menu-wrapper');
const menuItems = Array.from(document.querySelectorAll('.js-menu-item'));
const subMenuItems = Array.from(document.querySelectorAll('.js-submenu'));
const subMenuToggles = Array.from(document.querySelectorAll('.js-menu-toggle'));

let isOpen = false;

export function init() {
	menuOpener.addEventListener('click', openMenu);
	menuCloser.addEventListener('click', closeMenu);
	menuWrapper.addEventListener('click', onDocumentClick);
	document.addEventListener('keydown', onKeydown);

	menuItems.forEach(item => {
		item.addEventListener('click', function(event) {
			subMenuItems.forEach(subItem => {
				if (subItem.id == item.id) {
					subItem.classList.add('is-active');
					subItem.setAttribute('aria-expanded', 'true');
					menuWrapper.classList.toggle('is-first');
				}
			});
		});
	});

	subMenuToggles.forEach(button => {
		button.addEventListener('click', function(event) {
			event.stopPropagation();
			subMenuItems.forEach(el => {
				if (el.classList.contains('is-active')) {
					el.classList.remove('is-active');
					el.setAttribute('aria-expanded', 'false');
					menuWrapper.classList.toggle('is-first');
				}
			});
		});
	});

	function onDocumentClick(event) {
		if (!menu.contains(event.target) && isOpen) closeMenu();
	}

	function onKeydown(event) {
		if (event.key == 'Escape') closeMenu();
	}

	function openMenu() {
		menuWrapper.classList.toggle('is-active');
		menuWrapper.classList.add('is-first');

		isOpen = true;
	}

	function closeMenu() {
		menuWrapper.classList.remove('is-active');
		menuWrapper.classList.remove('is-first');

		isOpen = false;
	}
}
